export enum InventoryDocumentErrorCodes {
    RequestedQuantityOfProductIsNotAvailable = 'RequestedQuantityOfProductIsNotAvailable',
    GoodsReceiptLinkedWithGoodsIssueCannotBeChanged = 'GoodsReceiptLinkedWithGoodsIssueCannotBeChanged',
    CommercialDocumentAlreadyRelatedWithInventoryDocument = 'CommercialDocumentAlreadyRelatedWithInventoryDocument',
    ResourceAlreadyLocked = 'ResourceAlreadyLocked',
    DocumentContainsInactiveProducts = 'DocumentContainsInactiveProducts'
}

export type RequestedQuantityOfProductNotPresentInInventoryErrorObject = {
    productId: number;
    inventoryId: number;
};
